import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram } from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    // Add this line to include the referer (hostname)
    formData.append("referer", window.location.hostname);

    try {
      const res = await fetch(
        "https://script.google.com/macros/s/AKfycbyTV4qWzsfnv2pHCAZ9Hs6YE9je7AdwiDmC8c93kZI-6HmqyrJTfn4dhBoPEytuyq2l/exec",
        {
          method: "POST",
          body: new URLSearchParams(formData),
        }
      );
      if (res.ok) setSubmitted(true);
      setEmail("");
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  return (
    <footer className="bg-white py-6 border-t">
      <div className="px-4 md:px-[1.875rem] max-w-xl mx-auto mb-4 text-center">
        <h3 className="text-lg font-semibold text-[#6b492a] mb-1">
          Join Our Newsletter
        </h3>
        <p className="text-sm text-gray-600 mb-2">
          Keep up with the latest happenings at Bistro Espresso.
        </p>
        {!submitted ? (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-2"
          >
            {/* Honeypot field */}
            <input
              type="text"
              name="nickname"
              className="hidden"
              autoComplete="off"
            />
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-[#6b492a] text-white rounded-md hover:opacity-90 transition"
            >
              Subscribe
            </button>
          </form>
        ) : (
          <p className="text-green-600 text-sm">Thanks for subscribing!</p>
        )}
      </div>

      <div className="px-4 md:px-[1.875rem] flex justify-between items-center">
        {/* Social Media Icons */}
        <div className="flex gap-2.5">
          <a
            href="https://www.facebook.com/BistroEspresso/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#6b492a] text-white p-1.5 rounded-full hover:opacity-90 transition-opacity"
          >
            <FaFacebookF size={17} />
          </a>
          <a
            href="https://www.instagram.com/bistro_espresso/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#6b492a] text-white p-1.5 rounded-full hover:opacity-90 transition-opacity"
          >
            <FaInstagram size={17} />
          </a>
        </div>

        {/* Navigation Links */}
        <div className="flex items-center gap-3.5">
          <Link
            to="/contact"
            className="text-gray-800 hover:text-[#6b492a] transition-colors font-semibold text-[13px]"
          >
            CONTACT
          </Link>
          <Link
            to="/jobs"
            className="bg-[#64785d] text-white px-3.5 py-1.5 rounded hover:opacity-90 transition-opacity text-[13px]"
          >
            JOIN US
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
